'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.set = set;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET = 'seo/SET';

var initialState = {};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET:
      return (0, _extends3.default)({}, action.seo);
    default:
      return state;
  }
}

function set(seo) {
  var meta = [];
  if (seo.description) {
    meta.push({
      name: 'description',
      content: seo.description
    });
  }
  if (seo.keywords) {
    meta.push({
      name: 'keywords',
      content: seo.keywords
    });
  }

  var link = [];
  if (seo.canonical) {
    link.push({
      rel: 'canonical',
      href: seo.canonical
    });
  }
  seo.hreflangs.forEach(function (item) {
    link.push({
      rel: 'alternate',
      href: item.href,
      hrefLang: item.hreflang
    });
  });

  return {
    type: SET,
    seo: {
      pathname: seo.pathname,
      title: seo.title,
      meta: meta,
      link: link
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/modules/seo.js
// module id = 593
// module chunks = 0